export default __webpack_public_path__ + "static/media/padlock-locked.inline.12d17cc5.svg";